import React from "react";
import { IconButton, Stack, Typography } from "@mui/material";

import { HubButton, HubIcon } from "../../components";

const QuoteBar = ({ onClose = () => {} }) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    sx={{
      padding: "8px 12px",
      borderBottom: "1px solid",
      borderColor: "hubColors.greyLight",
      minHeight: 44,
    }}
  >
    <Stack direction="row" gap="6px" alignItems="center">
      <IconButton size="small" onClick={onClose} sx={{ padding: "4px" }}>
        <HubIcon icon="X" size={16} />
      </IconButton>
      <Typography variant="boldCaptionL" fontSize={13}>
        Quote
      </Typography>
    </Stack>
    <Stack direction="row" gap="8px" alignItems="center">
      <HubButton label="Save" variant="contained" size="xsmall" type="submit" />
    </Stack>
  </Stack>
);

export default QuoteBar;
